export default __webpack_public_path__ + "static/media/fail.c0e57d60.png";